import React, { useEffect, useRef, useState } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import { useAppSelector } from 'app/hooks';
import { api } from 'services/api';

import styles from './styles.module.scss';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const user = useAppSelector(state => state.auth.user);
  const email = user?.email || '';
  const applicationsLeft = user?.applicationsLeft || 0;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    navigate('/vacancies/create');
  };

  const handleBuyApplications = () => {
    const message = `Почта: ${email}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://t.me/wizex_support?text=${encodedMessage}`, '_blank');
  };

  const handleSupport = () => {
    window.open('https://t.me/wizex_support', '_blank');
  };

  const handleLogout = async () => {
    try {
      await api('auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      localStorage.removeItem('access_token');
      navigate('/login');
    }
  };


  return (
    <header className={styles.header}>
      <Link to='/vacancies' className={styles.logo}>wizex</Link>

      <div className={styles.right}>
        <button className={styles.newVacancy} onClick={handleClick}>
          <AddIcon />
          <span>Новая вакансия</span>
        </button>
        <button className={styles.supportButton} onClick={handleSupport}>
          <SupportAgentIcon />
        </button>
        <div ref={wrapperRef} className={styles.user}>
          <AccountCircleIcon
            className={styles.icon}
            onClick={() => setDropdownOpen(prev => !prev)}
          />
          {dropdownOpen && (
            <div className={styles.dropdown}>
              <div>Почта <br /><span>{email}</span></div>
              <div>Доступно откликов <br /><span>{applicationsLeft}</span></div>
              <button className={styles.pay} onClick={handleBuyApplications}>Купить отклики</button>
              <button className={styles.logout} onClick={handleLogout}>
                <LogoutIcon />&nbsp;Выйти
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
